import PropTypes from 'prop-types';

/**
 * What you have.
 *
 * REACT RATHER THAN CANVAS, unlike everything the engine draws. The rule this
 * project keeps is that React never renders game ENTITIES, because those change
 * twenty times a second inside a rAF loop that must not trigger a re-render. A
 * balance changes when you pick something up — a handful of times a minute — so
 * it is exactly what React is for, and putting it on the canvas would mean
 * hand-laying out a box Tailwind already lays out.
 *
 * NOBODY ELSE'S NUMBER IS EVER HERE. The server only ever sends you your own
 * (see BALANCE in game/events.js), so "is money visible to others?" stays an
 * open question in docs/game-design.md rather than being answered by accident.
 */
function Wallet({ coins }) {
  /**
   * NULL IS NOT ZERO, and rendering nothing is the whole reason this check
   * exists. The balance is read from the ledger asynchronously on join, so
   * there is a real window before the first number arrives. Showing "0 coins"
   * during it would be indistinguishable, to somebody with four hundred, from
   * having been robbed.
   */
  if (coins === null || coins === undefined) return null;

  return (
    <div className="flex items-center gap-1 rounded-lg bg-gray-950/70 px-2 py-1 text-xs backdrop-blur-sm">
      <span aria-hidden="true" className="text-primary">◉</span>
      <span className="font-medium text-gray-100">{coins}</span>
      <span className="text-gray-400">{coins === 1 ? 'coin' : 'coins'}</span>
    </div>
  );
}

Wallet.propTypes = {
  coins: PropTypes.number,
};

Wallet.defaultProps = {
  coins: null,
};

export default Wallet;
